import { render, staticRenderFns } from "./re-account.vue?vue&type=template&id=fa911018&"
import script from "./re-account.vue?vue&type=script&lang=js&"
export * from "./re-account.vue?vue&type=script&lang=js&"
import style0 from "./re-account.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports